import SeasonalPaywall, {
  SeasonalPaywallColors,
} from "../SeasonalPaywall/SeasonalPaywall"
import useStrings from "../../localization/useStrings"
import styles from "./HalloweenPaywall.module.scss"
import images from "../../utils/images"

const halloweenColors: SeasonalPaywallColors = {
  scrollableGradient: "black",
  header: {
    background: "transparent",
    title: "#FB8101",
    tagline: "white",
  },
  countdown: {
    boxBackground: "#1B2A34",
    value: "white",
    unit: "rgba(255, 255, 255, 0.6)",
    label: "rgba(255, 255, 255, 0.6)",
  },
  content: {
    background: "black",
    ultimateContainerBackground: "#FB8101",
    ultimateContainerText: "black",
    ultimateContainerMarginTop: "2px",
  },
  features: {
    icon: "#62646B",
    title: "white",
    description: "#62646B",
  },
  footer: {
    background: "#1B2A34",
    primaryButton: {
      background: "#FB8101",
      headerBackground: "#FB8101",
      contentBackground: "black",
      limitedTimeText: "black",
      saveTagText: "black",
      planTitle: "white",
      duration: "white",
      originalPrice: "white",
      discountedPrice: "#62646B",
      monthlyRate: "white",
    },
    monthlyButton: {
      background: "black",
      border: "none",
      label: "white",
      price: "white",
    },
  },
  insets: {
    header: "#000000",
    footer: "#1B2A34",
  },
  closeButton: "#E8E9EA",
}

const HalloweenPaywall = () => {
  const strings = useStrings()

  return (
    <SeasonalPaywall
      topDecoration={
        <div className={styles.headerContainer}>
          <div
            className={`${styles.header} ${images.halloween.header.class}`}
          />
        </div>
      }
      footerBackground={
        <div className={styles.footerContainer}>
          <div
            className={`${styles.footer} ${images.halloween.footer.class}`}
          />
        </div>
      }
      colors={halloweenColors}
      strings={{
        title: strings.halloweenSale.title,
        tagline: strings.halloweenSale.tagline,
        buttonTitle: strings.halloweenSale.buttonTitle,
      }}
      headerSpacing="-20px"
      topInsetPercent={0}
    />
  )
}

export default HalloweenPaywall
